import { connect } from 'react-redux';
import { fetchCustomers, fetchCustomersPaginate, selectCustomer, resetCurrentCustomer, attachDocument } from '../../actions/customers_actions';

import Customers from '../../components/Customers/customers';

function mapStateToProps(state) {
  return {
    customers: state.customers.all,
    customerTotalPages: state.customers.customerTotalPages,
    customerTotalCount: state.customers.customerTotalCount,
    currentCustomer: state.customers.currentCustomer,
    isLoading: state.customers.isLoading,
    error: state.customers.error,
    userPermissions: state.auth.userPermissions,
    isAttachingDocument: state.customers.isAttachingDocument,
  };
}

export default connect(mapStateToProps, {
  fetchCustomers,
  fetchCustomersPaginate,
  selectCustomer,
  resetCurrentCustomer,
  attachDocument,
})(Customers);



// WEBPACK FOOTER //
// ./master/jsx/containers/Customers/customers.jsx